import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,) { }

  registerIcon(icons: Array<string>): void {

    icons.forEach(i => this.matIconRegistry.addSvgIcon(
      i,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/images/${i}.svg`)
    ))
  }

}
